import { BFormCheckboxGroup, BFormGroup } from 'bootstrap-vue'
export default {
    components: {
        BFormCheckboxGroup, BFormGroup,
    },
    data(){
        return {
            communicationOptions: [
                { text: 'SMS', value: 'sms' },
                { text: 'Email', value: 'email' },
                { text: 'Push Notification', value: 'push' },
            ],
        }
    },
    computed: {
        modCom() {
            if (this.$store.state.auth.user) {
                return this.$store.state.auth.user.settings.communication_modes
            } else {
                return [];
            }
        },
        notifications() {
            if (this.$store.state.auth.user) {
                return this.$store.state.auth.user.settings.notifications
            } else {
                return []
            }
        }
    },
    methods:{
        async changed(type, settings_id){
            try {
                const resp = await this.$http.post('/update-settings', {
                    type,
                    settings_id,
                });
                if(resp.status === 200 && resp.data && resp.data.status){
                    this.$helper.showMessage(resp.data.message);
                }
            } catch(e) {
                this.$helper.showMessage('Oops! Something went wrong', 'danger');
            }
        }
    }
};